module.exports = __webpack_public_path__ + "static/img/1600.05147cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s31/pop/1600.png
// module id = lrMQ
// module chunks = 2